import React from 'react';
import { FormattedMessage } from 'react-intl';

import { SliderBox } from '../../../molecules/slider-box';
import { SwitchBox } from '../../../molecules/switch-box';
import { ParentPaper } from '../../../atoms/parent-paper';
import { HelpButton } from '../../../atoms/help-button';

export const SettingsSpBatteryToGrid = () => {
  return (
    <ParentPaper>
      <SwitchBox
        title={
          <>
            <FormattedMessage
              id="settings.spot.battery_overflow"
              defaultMessage="Povolit vybíjení baterie do sítě podle spotu"
            />
            <HelpButton
              variant="dialog"
              title={
                <FormattedMessage
                  id="settings.spot.battery_overflow"
                  defaultMessage="Povolit vybíjení baterie do sítě podle spotu"
                />
              }
              content={
                <FormattedMessage
                  id="settings.spot.battery_overflow.help"
                  defaultMessage="Pokud zvolíte tuto možnost, tak systém naplánuje vybíjení baterie do sítě v době nejvyšší denní ceny a vybije jen tu energii, která nebude potřeba na běžnou spotřebu objektu. Parametry níže je možné definovat výši ceny pro vybítí celé kapacity baterie a vybítí jen té části kapacity baterie, která nebude potřeba pro noční spotřebu. "
                />
              }
            />
          </>
        }
        switchVariableId="SP_DISCHARGE_TO_GRID"
        subtitle={
          <FormattedMessage
            id="settings.spot.battery_overflow.subtitle"
            defaultMessage="Umožní vybít nadbytek energie z baterie do sítě v nejvýhodnější hodinu"
          />
        }
        visibility={{
          variableIds: [
            'SP_INSTALL',
            'SP_DISCHARGE_TO_GRID_SER',
            'PV_BATTERY_CONTROL',
          ],
        }}
        fullWidth
      />
      <SliderBox
        title={
          <>
            <FormattedMessage
              id="settings.spot.battery_overflow_price"
              defaultMessage="Minimální cena pro vybíjení baterie do sítě"
            />
            <HelpButton
              variant="dialog"
              title={
                <FormattedMessage
                  id="settings.spot.battery_overflow_price"
                  defaultMessage="Minimální cena pro vybíjení baterie do sítě"
                />
              }
              content={
                <FormattedMessage
                  id="settings.spot.battery_overflow_price.help"
                  defaultMessage="Pokud je cena spotu vyšší než tato hodnota, dojde v té době k vybíjení pouze přebytečné kapacity baterie do sítě. Znamená to tedy, že v baterii uchováváme energii pro noční a ranní spotřebu objektu. Nebude tedy docházet k nakupování energie ze sítě"
                />
              }
            />
          </>
        }
        variableId="SP_DISCHARGE_TO_GRID_MIN_PRICE"
        subtitle={
          <FormattedMessage
            id="settings.spot.battery_overflow_price.subtitle"
            defaultMessage="Pokud je cena spotu vyšší než tato hodnota, dojde v té době k vybíjení pouze přebytečné kapacity baterie do sítě"
          />
        }
        opts={{ style: 'currency' }}
        visibility={{
          variableIds: [
            'SP_INSTALL',
            'SP_DISCHARGE_TO_GRID',
            'SP_DISCHARGE_TO_GRID_SER',
            'PV_BATTERY_CONTROL',
          ],
        }}
        min={{ CZK: 2, EUR: 0.1 }}
        max={{ CZK: 20, EUR: 1 }}
      />
      <SliderBox
        title={
          <>
            <FormattedMessage
              id="settings.spot.battery_all_overflow_price"
              defaultMessage="Minimální cena pro vybíjení celé kapacity baterie do sítě"
            />
            <HelpButton
              variant="dialog"
              title={
                <FormattedMessage
                  id="settings.spot.battery_all_overflow_price"
                  defaultMessage="Minimální cena pro vybíjení celé kapacity baterie do sítě"
                />
              }
              content={
                <FormattedMessage
                  id="settings.spot.battery_all_overflow_price.help"
                  defaultMessage="Pokud je cena spotu vyšší než tato hodnota, dojde v té době k vybíjení kapacity baterie do sítě až do nastaveného minimálního SOC. Znamená to tedy, že v baterii nebude uchována energie pro noční a ranní spotřebu. Po vybití baterie do sítě se bude pro spotřebu objektu nakupovat energie ze sítě"
                />
              }
            />
          </>
        }
        variableId="SP_DISCHARGE_ALL_TO_GRID_MIN_PRICE"
        subtitle={
          <FormattedMessage
            id="settings.spot.battery_all_overflow_price.subtitle"
            defaultMessage="Pokud je cena spotu vyšší než tato hodnota, dojde v té době k vybíjení kapacity baterie do sítě až do nastaveného minimálního SOC"
          />
        }
        opts={{ style: 'currency' }}
        visibility={{
          variableIds: [
            'SP_INSTALL',
            'SP_DISCHARGE_TO_GRID',
            'SP_DISCHARGE_TO_GRID_SER',
            'PV_BATTERY_CONTROL',
          ],
        }}
        min={{ CZK: 5, EUR: 0.25 }}
        max={{ CZK: 20, EUR: 1 }}
      />
    </ParentPaper>
  );
};
